import type {
  RenterRentAmountChangeRequestInterface,
  RenterRentAmountChangeRequestNumericInputInterface,
  RenterRentTermsInterface,
  RenterRentTermsNumericInputInterface,
} from './Types';
import { formatTimestampToYMDString } from '@common/paymentsUtils/dateUtils';

const RentAmountChangeRequest = (
  rentAmountChangeRequest?: RenterRentAmountChangeRequestNumericInputInterface,
): RenterRentAmountChangeRequestInterface => {
  const { effectiveDueDate = 0, newAmount, renterAcceptanceDate = 0, expired } = rentAmountChangeRequest || {};

  return {
    effectiveDueDate: formatTimestampToYMDString(effectiveDueDate),
    newAmount: newAmount && Number(newAmount),
    renterAcceptanceDate: formatTimestampToYMDString(renterAcceptanceDate),
    expired: expired && Boolean(expired),
  };
};

const RentTermsModel = (rentTerms: RenterRentTermsNumericInputInterface): RenterRentTermsInterface => {
  const {
    amount = 0,
    address = '',
    firstDueDate = 0,
    monthToMonth = false,
    numberOfPayments = 0,
    rentAmountChangeRequest = {},
    rentTermsKey = '',
    addressInfo = {},
  } = rentTerms || {};

  return {
    address,
    amount: amount && Number(amount),
    firstDueDate: formatTimestampToYMDString(firstDueDate),
    monthToMonth,
    numberOfPayments: numberOfPayments && Number(numberOfPayments),
    rentAmountChangeRequest: rentAmountChangeRequest && RentAmountChangeRequest(rentAmountChangeRequest),
    rentTermsKey,
    addressInfo,
  };
};

export default RentTermsModel;
